var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618",
    transform: "translate(-382 -1858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    transform: "translate(382 1858)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "odnoklassniki",
    transform: "translate(398.5 1863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M5.256,14.817c-2.1,4.122.284,6.092,5.716,9.458,4.618,2.853,11,3.9,15.095,4.313l-3.434,3.3c-4.867,4.635-9.485,9.122-12.714,12.232-4.7,4.5,2.866,11.732,7.563,7.323L30.195,39.185c4.867,4.683,9.533,9.17,12.714,12.28,4.7,4.426,12.262-2.74,7.614-7.323L37.809,31.91l-3.482-3.3c4.149-.417,10.433-1.522,15-4.313l0,0c5.432-3.383,7.812-5.35,5.746-9.471-1.248-2.34-4.614-4.3-9.1-.913a27.7,27.7,0,0,1-15.81,4.635A27.691,27.691,0,0,1,14.351,13.9c-4.481-3.4-7.86-1.426-9.1.913Z",
    transform: "translate(0 29.242)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M27.294,41.532c11.9,0,21.611-9.3,21.611-20.742C48.9,9.3,39.191,0,27.294,0S5.68,9.3,5.68,20.79C5.68,32.235,15.394,41.532,27.294,41.532Zm0-31A10.447,10.447,0,0,1,37.908,20.79,10.438,10.438,0,0,1,27.294,31,10.438,10.438,0,0,1,16.68,20.79,10.44,10.44,0,0,1,27.294,10.532Z",
    transform: "translate(2.856)",
    fill: "#ffc107"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA8);
export default __webpack_public_path__ + "static/media/a8.a966423b56b584cbdd34f495cdcea242.svg";
export { ForwardRef as ReactComponent };